import { Injectable } from '@angular/core';

/**
 * Erases the password that earlier versions of the application left on disk.
 *
 * WHAT WAS THERE. Signing up with an email address used to create no account:
 * the password screen wrote the address AND THE PASSWORD to localStorage under
 * `pendingEmailSignup`, so that the onboarding screen could replay the Firebase
 * sign-up once the profile form was filled in. WebView localStorage is a plain
 * SQLite file in the app container: it survives restarts and app updates, and it
 * is carried into unencrypted device backups. Anything that could read the
 * container read the password.
 *
 * Every release since 2.0.1 on 31 May 2026 wrote one, including 2.1.4, which is
 * the version in the stores. Those entries are only cleared on a completed
 * onboarding or a later sign-in, so anyone who gave up part-way still has
 * theirs. Not writing any more was half a fix; this is the other half, and it is
 * the reason this service still exists.
 *
 * NOTHING WRITES THAT KEY ANY MORE. The credentials were first moved into
 * memory, and then stopped being kept at all: the account is created as soon as
 * the password is confirmed, so there is nothing to carry from one screen to the
 * next. This service is what is left of PendingSignupService, and all it does is
 * clean up after the versions that did.
 */
@Injectable({ providedIn: 'root' })
export class LegacyPasswordPurge {
  /** The key earlier versions wrote a password under. */
  private static readonly LEGACY_STORAGE_KEY = 'pendingEmailSignup';

  /**
   * Called once at start-up. Wrapped because localStorage throws rather than
   * returning null in some contexts, and failing to clean up must never stop the
   * app from booting.
   */
  purgeLegacyStorage(): void {
    try {
      localStorage.removeItem(LegacyPasswordPurge.LEGACY_STORAGE_KEY);
    } catch {
      // Nothing to do: an unreadable store holds nothing we can erase either.
    }
  }
}
